'use client';

import { c as _c } from "react/compiler-runtime";
import { type MotionStyle, useScroll, useSpring, useTransform } from 'motion/react';
const TOP_HEADER_HIDE_START = 100;
const TOP_HEADER_HIDE_END = 150;
const SEARCH_RESIZE_END = 0.25;
const LOGO_ANIMATION_END = 0.6;
const LOGO_INTERACTION_DISABLE_PROGRESS = LOGO_ANIMATION_END * 0.5;
export function useStickyHeaderAnimation() {
  const $ = _c(30);
  const {
    scrollY
  } = useScroll();
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [TOP_HEADER_HIDE_START, TOP_HEADER_HIDE_END];
    t1 = [0, 1];
    t2 = {
      clamp: true
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  const scrollProgress = useTransform(scrollY, t0, t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      damping: 100,
      stiffness: 1000
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const progress = useSpring(scrollProgress, t3);
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [0, SEARCH_RESIZE_END, 1];
    t5 = ["7.5rem", "7.5rem", "4rem"];
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  const mainSectionMaxHeight = useTransform(progress, t4, t5);
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [0, SEARCH_RESIZE_END, 1];
    t7 = ["0rem", "0rem", "-3.25rem"];
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  const searchTop = useTransform(progress, t6, t7);
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [0, SEARCH_RESIZE_END, 1];
    t9 = ["0rem", "3.5rem", "3.5rem"];
    $[8] = t8;
    $[9] = t9;
  } else {
    t8 = $[8];
    t9 = $[9];
  }
  const searchLeft = useTransform(progress, t8, t9);
  let t10;
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = [0, SEARCH_RESIZE_END, 1];
    t11 = ["0rem", "6.5rem", "6rem"];
    $[10] = t10;
    $[11] = t11;
  } else {
    t10 = $[10];
    t11 = $[11];
  }
  const searchRight = useTransform(progress, t10, t11);
  let t12;
  let t13;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = [0, SEARCH_RESIZE_END, 1];
    t13 = ["0rem", "6rem", "6rem"];
    $[12] = t12;
    $[13] = t13;
  } else {
    t12 = $[12];
    t13 = $[13];
  }
  const aiAssistRight = useTransform(progress, t12, t13);
  let t14;
  let t15;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = [0, LOGO_ANIMATION_END];
    t15 = ["0rem", "-1.25rem"];
    $[14] = t14;
    $[15] = t15;
  } else {
    t14 = $[14];
    t15 = $[15];
  }
  const logoY = useTransform(progress, t14, t15);
  let t16;
  let t17;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = [0, LOGO_ANIMATION_END];
    t17 = [1, 0];
    $[16] = t16;
    $[17] = t17;
  } else {
    t16 = $[16];
    t17 = $[17];
  }
  const logoOpacity = useTransform(progress, t16, t17);
  let t18;
  let t19;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = [0, LOGO_ANIMATION_END];
    t19 = [1, 0.8];
    $[18] = t18;
    $[19] = t19;
  } else {
    t18 = $[18];
    t19 = $[19];
  }
  const logoScale = useTransform(progress, t18, t19);
  const logoPointerEvents = useTransform(progress, _temp);
  let t20;
  if ($[20] !== aiAssistRight || $[21] !== logoOpacity || $[22] !== logoPointerEvents || $[23] !== logoScale || $[24] !== logoY || $[25] !== mainSectionMaxHeight || $[26] !== searchLeft || $[27] !== searchRight || $[28] !== searchTop) {
    t20 = {
      "--header-search-top": searchTop,
      "--header-search-left": searchLeft,
      "--header-search-right": searchRight,
      "--header-ai-assist-right": aiAssistRight,
      "--header-main-section-max-height": mainSectionMaxHeight,
      "--header-logo-opacity": logoOpacity,
      "--header-logo-y": logoY,
      "--header-logo-scale": logoScale,
      "--header-logo-pointer-events": logoPointerEvents
    };
    $[20] = aiAssistRight;
    $[21] = logoOpacity;
    $[22] = logoPointerEvents;
    $[23] = logoScale;
    $[24] = logoY;
    $[25] = mainSectionMaxHeight;
    $[26] = searchLeft;
    $[27] = searchRight;
    $[28] = searchTop;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  return t20 as MotionStyle;
}
function _temp(value) {
  return value >= LOGO_INTERACTION_DISABLE_PROGRESS ? "none" : "auto";
}